import { useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import React from 'react'
import { useSiteConfig } from 'src/lib/siteconfig'

import { Actions, Categories } from '../../lib/analytics/events'
import { Theme } from '../../lib/theming/Theme'
import ActionGroup, { ActionGroupType } from '../menu/ActionGroup'
import Menus from '../menu/Menus'
import Navigation from '../menu/Navigation'
import { usePageConfig } from '../PageConfig/PageConfigProvider'
import Header from './Header'
import HeaderLogo from './HeaderLogo'

const HeaderProvider = () => {
  const theme = useTheme<Theme>()
  const mdUp = useMediaQuery(theme.breakpoints.up('md'))
  const { logo: eventLogo } = useSiteConfig()
  const {
    logos,
    callsToAction: [firstCTA, secondCTA],
    menus: { header1, header2, header3, socials },
  } = usePageConfig()

  const menus = [
    { menu: header1 },
    {
      menu: header2,
      separators: {
        after: true,
        before: true,
      },
    },
    { menu: header3, socialsMenu: socials },
  ]

  const styles = {
    backgroundColor: theme.palette.primary.main,
    height: 'auto',
    iconColor: theme.palette.common.white,
    textColor: theme.palette.secondary.main,
  }

  let logoComponent
  if (eventLogo?.absoluteUrl) {
    logoComponent = (
      <HeaderLogo
        logo={{
          altText: eventLogo?.alternativeText,
          id: eventLogo?.id,
          url: eventLogo?.absoluteUrl,
        }}
      />
    )
  } else {
    let logo = logos?.mobileLogo
    if (mdUp) {
      logo = logos?.useSvgAsLogo && logos.svgLogo ? logos.svgLogo : logos?.logo
    }
    const slideOutAmount = (mdUp && logos?.slideOutAmount) || null
    const slideOutAnimation = (mdUp && logos?.slideOutAnimation) || null
    const confDates = logos?.conferenceDates
    logoComponent = (logo || confDates) && (
      <HeaderLogo
        logo={{
          altText: logo?.altText,
          id: logo?.id,
          url: logo?.sourceUrl,
        }}
        slideOutAmount={slideOutAmount}
        slideOutAnimation={slideOutAnimation}
      />
    )
  }

  const actions: ActionGroupType = []
  if (secondCTA) {
    actions.push({
      children: secondCTA.label,
      tracking: {
        action: Actions.CTAButtonClick,
        category: Categories.HeaderMenu,
        label: secondCTA.label,
      },
      url: secondCTA.url,
      variant: 'secondaryOutline',
    })
  }
  if (firstCTA) {
    actions.push({
      children: firstCTA.label,
      tracking: {
        action: Actions.CTAButtonClick,
        category: Categories.HeaderMenu,
        label: firstCTA.label,
      },
      url: firstCTA.url,
      variant: 'secondaryFill',
    })
  }

  const actionGroupElem = <ActionGroup actions={actions} />
  const menusComponent = menus && <Menus ctas={actionGroupElem} menus={menus} styles={styles} />

  const navigationComponent = <Navigation menus={menusComponent} styles={styles} />

  return (
    <Header
      actions={<ActionGroup actions={actions} />}
      logo={logoComponent}
      navigation={navigationComponent}
      styles={styles}
    />
  )
}

export default HeaderProvider
